module.exports = __webpack_public_path__ + "static/media/heart.5e99dccb.svg";